import {EventEmitter, Injectable} from '@angular/core';
import {SysConfigService} from './sys-config.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {UserRoleCategoryModel} from '../dto/user-role-category.model';
import {Observable} from 'rxjs/internal/Observable';
import {UserRoleModel} from '../dto/user-role.model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class UserroleCategoryService {
  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';
  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });

  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }
  resultSet = new EventEmitter<Array<UserRoleCategoryModel>>();

  roleCategorySearchDetailsChange = new EventEmitter<UserRoleCategoryModel[]>();

  private roleCategorySearchDetailsItem: UserRoleCategoryModel[] = [];

  /** get all user role category details **/
  getAllUserRoleCategory(){
    return this.httpClient.get(this.BASE_URL + 'userRoleCategory' + "/")
  }

  public saveUserRoleCategory(dto: UserRoleCategoryModel): Observable<any> {
    return this.httpClient.post(this.BASE_URL + 'userRoleCategory/save', dto, { responseType: 'text' });
  }
  public editUserRoleCategory(dto: UserRoleCategoryModel): Observable<any> {
    return this.httpClient.put(this.BASE_URL + 'userRoleCategory/', dto, { responseType: 'text' });
  }
  public deleteUserRoleCategory(code: string) {
    return this.httpClient.delete(this.BASE_URL + 'userRoleCategory/' + code ,{ headers: this.headers });
  }
  public getAllUserRoleCategories(): Observable<Array<UserRoleCategoryModel>> {
    return this.httpClient.get<Array<UserRoleCategoryModel>>(this.BASE_URL + 'userRoleCategory/');
  }

  /** Search UserRole Category Details **/
  getUserRoleCategoryDetails(roleCategory :UserRoleCategoryModel) {
    return this.httpClient.post(this.BASE_URL + 'userRoleCategory/', roleCategory, { headers: this.headers });
  }

  /** reset searched details **/
  clearUserRoleSearchDetails() {
    this.roleCategorySearchDetailsItem = [];
    this.roleCategorySearchDetailsChange.emit(this.roleCategorySearchDetailsItem);
  }

  /** set search details in the table **/
  setUserRoleSearchDetails(userRoleSearchDetails: UserRoleCategoryModel[]) {
    this.roleCategorySearchDetailsItem = userRoleSearchDetails;
    this.roleCategorySearchDetailsChange.emit(this.roleCategorySearchDetailsItem);
  }
}
